/**
 * @generated SignedSource<<fadc081bffa206c3c3acb602760b1522>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileOverviewOneQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileOverviewOneQuery$data = {
  readonly micrositeTopicOverviewCollection: {
    readonly items: ReadonlyArray<{
      readonly author: {
        readonly authorPicture: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly size: number | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly jobTitle: string | null | undefined;
        readonly name: string | null | undefined;
        readonly organization: {
          readonly industryCollection: {
            readonly items: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly shortDescription: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly logoCollection: {
            readonly items: ReadonlyArray<{
              readonly contentType: string | null | undefined;
              readonly description: string | null | undefined;
              readonly fileName: string | null | undefined;
              readonly height: number | null | undefined;
              readonly size: number | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly width: number | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly shortDescription: string | null | undefined;
          readonly tagline: string | null | undefined;
        } | null | undefined;
        readonly shortBiography: string | null | undefined;
      } | null | undefined;
      readonly bodyTextContainerCollection: {
        readonly items: ReadonlyArray<{
          readonly contentComponents: {
            readonly items: ReadonlyArray<{
              readonly __typename: "AssetComponent";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly size: number | null | undefined;
                readonly title: string | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly assetRelatedText: {
                readonly json: any;
              } | null | undefined;
              readonly caption: string | null | undefined;
            } | {
              readonly __typename: "CallToAction";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly size: number | null | undefined;
                readonly title: string | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly ctaText: string | null | undefined;
              readonly dataBlueprintModule: string | null | undefined;
              readonly productCollection: {
                readonly items: ReadonlyArray<{
                  readonly productLogo: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly size: number | null | undefined;
                    readonly title: string | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly productNameReference: {
                    readonly productName: string | null | undefined;
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly valueProposition: string | null | undefined;
            } | {
              readonly __typename: "EmbeddedVideoAsset";
              readonly embedAssetOverlay: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly size: number | null | undefined;
                readonly title: string | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly embedded: string | null | undefined;
              readonly embeddedVideoAssetName: string | null | undefined;
            } | {
              readonly __typename: "ProTipComponent";
              readonly name: string | null | undefined;
              readonly proTipText: string | null | undefined;
            } | {
              readonly __typename: "TextComponent";
              readonly name: string | null | undefined;
              readonly text: {
                readonly json: any;
              } | null | undefined;
            } | {
              readonly __typename: "TwitterComponent";
              readonly tweetText: string | null | undefined;
              readonly twitterComponentName: string | null | undefined;
              readonly twitterUrl: string | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined>;
          } | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly nextBestActionCollection: {
        readonly items: ReadonlyArray<{
          readonly __typename: "MicrositeArticle";
          readonly articleBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly articleName: string | null | undefined;
          readonly description: string | null | undefined;
          readonly title: string | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          readonly __typename: "Tutorial";
          readonly description: string | null | undefined;
          readonly name: string | null | undefined;
          readonly title: string | null | undefined;
          readonly tutorialBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined>;
      } | null | undefined;
      readonly topicIntroductionCollection: {
        readonly items: ReadonlyArray<{
          readonly asset: {
            readonly items: ReadonlyArray<{
              readonly contentType: string | null | undefined;
              readonly description: string | null | undefined;
              readonly fileName: string | null | undefined;
              readonly height: number | null | undefined;
              readonly size: number | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly width: number | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly details: {
            readonly json: any;
          } | null | undefined;
          readonly embedLink: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly upNextFooter: {
        readonly articleBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly size: number | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly articleName: string | null | undefined;
        readonly description: string | null | undefined;
        readonly title: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | null | undefined;
      readonly urlSlug: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileOverviewOneQuery = {
  response: agileOverviewOneQuery$data;
  variables: agileOverviewOneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "urlSlug",
        "variableName": "urlSlug"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "supportingConceptNameExternal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "textComponentNameExternal",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "TextComponentText",
  "kind": "LinkedField",
  "name": "text",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": "caption",
  "args": null,
  "kind": "ScalarField",
  "name": "assetCaption",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetComponentAssetRelatedText",
  "kind": "LinkedField",
  "name": "assetRelatedText",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = [
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "proTipNameExternal",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proTipText",
  "storageKey": null
},
v16 = {
  "alias": "twitterComponentName",
  "args": null,
  "kind": "ScalarField",
  "name": "twitterComponentExternalName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tweetText",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterUrl",
  "storageKey": null
},
v19 = {
  "alias": "embeddedVideoAssetName",
  "args": null,
  "kind": "ScalarField",
  "name": "embeddedVideoAssetNameExternal",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "embedded",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "embedAssetOverlay",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v25 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v26 = {
  "alias": "asset",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "ctaAsset",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v28 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "productLogo",
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 2
  }
],
v31 = {
  "alias": "articleName",
  "args": null,
  "kind": "ScalarField",
  "name": "articleNameExternal",
  "storageKey": null
},
v32 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleBanner",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v35 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v36 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
},
v37 = {
  "alias": "description",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialDescription",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "tutorialBanner",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v39 = [
  (v31/*: any*/),
  (v32/*: any*/),
  (v11/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "MicrositeArticle",
  "kind": "LinkedField",
  "name": "upNextFooter",
  "plural": false,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Asset",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": (v12/*: any*/),
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": "name",
      "args": null,
      "kind": "ScalarField",
      "name": "authorNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortBiography",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "authorPicture",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNameInternal",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "organizationNameExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tagline",
          "storageKey": null
        },
        (v41/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "AssetCollection",
          "kind": "LinkedField",
          "name": "logoCollection",
          "plural": false,
          "selections": (v42/*: any*/),
          "storageKey": "logoCollection(limit:1)"
        },
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "CompanyNameInternalIndustryCollection",
          "kind": "LinkedField",
          "name": "industryCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaxonomyIndustry",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryName",
                  "storageKey": null
                },
                (v41/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "industryCollection(limit:1)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "MicrositeTopicOverviewTopicIntroductionCollection",
  "kind": "LinkedField",
  "name": "topicIntroductionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicIntroduction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "title",
          "args": null,
          "kind": "ScalarField",
          "name": "topicIntroductionTitleExternal",
          "storageKey": null
        },
        {
          "alias": "details",
          "args": null,
          "concreteType": "TopicIntroductionTopicIntroductionDetails",
          "kind": "LinkedField",
          "name": "topicIntroductionDetails",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embedLink",
          "storageKey": null
        },
        {
          "alias": "asset",
          "args": (v27/*: any*/),
          "concreteType": "AssetCollection",
          "kind": "LinkedField",
          "name": "topicIntroductionAssetCollection",
          "plural": false,
          "selections": (v42/*: any*/),
          "storageKey": "topicIntroductionAssetCollection(limit:1)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "topicIntroductionCollection(limit:1)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileOverviewOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MicrositeTopicOverviewCollection",
        "kind": "LinkedField",
        "name": "micrositeTopicOverviewCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MicrositeTopicOverview",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrositeTopicOverviewBodyTextContainerCollection",
                "kind": "LinkedField",
                "name": "bodyTextContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailParagraphWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": "contentComponents",
                        "args": null,
                        "concreteType": "DetailParagraphWrapperContentComponentsCollection",
                        "kind": "LinkedField",
                        "name": "contentComponentsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "EmbeddedVideoAsset",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "MicrositeTopicOverviewNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v11/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              (v40/*: any*/),
              (v43/*: any*/),
              (v34/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileOverviewOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MicrositeTopicOverviewCollection",
        "kind": "LinkedField",
        "name": "micrositeTopicOverviewCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MicrositeTopicOverview",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrositeTopicOverviewBodyTextContainerCollection",
                "kind": "LinkedField",
                "name": "bodyTextContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailParagraphWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": "contentComponents",
                        "args": null,
                        "concreteType": "DetailParagraphWrapperContentComponentsCollection",
                        "kind": "LinkedField",
                        "name": "contentComponentsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "EmbeddedVideoAsset",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "MicrositeTopicOverviewNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v39/*: any*/),
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              (v40/*: any*/),
              (v43/*: any*/),
              (v34/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91749574e036a0079e2cb21034607564",
    "id": null,
    "metadata": {},
    "name": "agileOverviewOneQuery",
    "operationKind": "query",
    "text": "query agileOverviewOneQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  micrositeTopicOverviewCollection(limit: $limit, where: {urlSlug: $urlSlug}, locale: $locale) {\n    items {\n      bodyTextContainerCollection {\n        items {\n          name: supportingConceptNameExternal\n          contentComponents: contentComponentsCollection {\n            items {\n              __typename\n              ... on TextComponent {\n                __typename\n                name: textComponentNameExternal\n                text {\n                  json\n                }\n              }\n              ... on AssetComponent {\n                __typename\n                caption: assetCaption\n                assetRelatedText {\n                  json\n                }\n                asset {\n                  description\n                  title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on ProTipComponent {\n                __typename\n                name: proTipNameExternal\n                proTipText\n              }\n              ... on TwitterComponent {\n                __typename\n                twitterComponentName: twitterComponentExternalName\n                tweetText\n                twitterUrl\n              }\n              ... on EmbeddedVideoAsset {\n                __typename\n                embeddedVideoAssetName: embeddedVideoAssetNameExternal\n                embedded\n                embedAssetOverlay {\n                  description\n                  title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on CallToAction {\n                __typename\n                title: ctaTitleExternal\n                valueProposition\n                ctaText\n                url: ctaUrl\n                asset: ctaAsset {\n                  description\n                  title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n                productCollection(limit: 1) {\n                  items {\n                    productNameReference {\n                      productName\n                    }\n                    productLogo: icon {\n                      description\n                      title\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                }\n                dataBlueprintModule\n              }\n            }\n          }\n        }\n      }\n      nextBestActionCollection(limit: 2) {\n        items {\n          __typename\n          ... on MicrositeArticle {\n            __typename\n            articleName: articleNameExternal\n            title: articleTitle\n            description\n            articleBanner {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n          ... on Tutorial {\n            __typename\n            name: tutorialNameExternal\n            title: tutorialTitle\n            description: tutorialDescription\n            tutorialBanner {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n        }\n      }\n      upNextFooter {\n        articleName: articleNameExternal\n        title: articleTitle\n        description\n        articleBanner {\n          description\n          title\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n        urlSlug\n      }\n      author {\n        name: authorNameExternal\n        jobTitle\n        shortBiography\n        authorPicture {\n          description\n          title\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n        organization {\n          name: organizationNameExternal\n          tagline\n          shortDescription\n          logoCollection(limit: 1) {\n            items {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n          industryCollection(limit: 1) {\n            items {\n              name: industryName\n              shortDescription\n            }\n          }\n        }\n      }\n      urlSlug\n      topicIntroductionCollection(limit: 1) {\n        items {\n          title: topicIntroductionTitleExternal\n          details: topicIntroductionDetails {\n            json\n          }\n          embedLink\n          asset: topicIntroductionAssetCollection(limit: 1) {\n            items {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "29e9be42202bc660bda8244c81253448";

export default node;
